// extracted by mini-css-extract-plugin
export default {"progress":"ZQ7Y5"};